<template>
  <v-app>
    <profile-update-dialog :dialog="dialog" :data="data" @update:dialog="dialog = $event" @update:data="data = $event"  />

    <v-container fluid class="pa-4">
      <v-card variant="elevated" :loading="profileLoading" class="ma-2">
        <template #loader>
          <v-progress-linear
              color="blue-darken-3"
              height="3.5"
              v-if="profileLoading"
              indeterminate
          />
        </template>
        <v-card-title class="text-h5">
          <v-row class="pb-0">
            <v-col cols="10">
              <div class="d-flex">

                <v-avatar
                    v-if="userPersonalInfoData?.user?.image"
                    :image="fileServerUrl + userPersonalInfoData?.user?.image"
                    :size="50"
                />
                <v-icon v-else>
                  mdi-account-circle
                </v-icon>
                <h4 class="ml-4">{{ userPersonalInfoData?.name }}</h4>
              </div>

              <div class="mb-3">

                <v-chip
                    color="green"
                    size="small"
                    variant="flat"
                    class="text-subtitle-2 ml-14"
                >
                  {{ userPersonalInfoData?.code }}
                </v-chip>

                <v-chip
                    color="green"
                    size="small"
                    class="text-sm-subtitle-2 ml-2"
                >
                  <v-icon start size="14" class="me-1">mdi-circle</v-icon>
                  {{ userPersonalInfoData?.status == 1? 'Active' : 'Inactive' }}
                </v-chip>
              </div>
            </v-col>

            <v-col cols="2">
              <v-card-actions>
                <v-btn
                    class="me-2"
                    color="primary"
                    variant="tonal"
                    prepend-icon="mdi-pencil-outline"
                    @click="editItem(mainId)"
                >
                  Edit Profile
                </v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>

      <v-card  :loading="loading" class="ma-2">
          <template #loader>
            <v-progress-linear
                color="blue-darken-3"
                height="3.5"
                v-if="loading"
                indeterminate
            />
          </template>

          <v-row no-gutters style="display: flex; align-items: center">
            <v-col cols="12" md="12" class="border-b">
              <v-tabs
                  v-model="tab"
                  color="primary"
                  align-tabs="end"
              >
                <v-tab
                    v-for="(assetDetail, idx) in assetRegistrationTabList"
                    :key="idx"
                    :value="assetDetail.value"
                    class="text-subtitle-2 font-weight-semibold">
                  <v-icon start>{{ assetDetail.icon }}</v-icon>
                  {{ assetDetail.title }}
                </v-tab>
              </v-tabs>
            </v-col>

            <v-col cols="12" md="12">
              <v-window v-model="tab">
                <user-details-personal-info-details
                    :user-personal-info-data="userPersonalInfoData"
                />
                <user-details-general-info-details
                    :user-general-info-data="userGeneralInfoData"
                />
                <user-details-settings-info-details
                    :user-settings-info-data="userSettingsInfoData"
                />
                <user-details-educational-info-details
                    :user-education-info-data="userEducationInfoData"
                />
                <user-details-address-info-details
                    :user-address-info-data="userAddressInfoData"
                />
                <user-details-experience-info-details
                    :user-experience-info-data="userExperienceInfoData"
                />
                <user-details-other-info-details
                    :user-other-info-data="userOthersInfoData"
                />
              </v-window>
            </v-col>
          </v-row>
        </v-card>

    </v-container>
  </v-app>
</template>

<script>

import UserDetailsPersonalInfoDetails from "@/components/module/administration/userManagement/userDetailsPersonalInfoDetails.vue";
import UserDetailsGeneralInfoDetails from "@/components/module/administration/userManagement/userDetailsGeneralInfoDetails.vue";
import UserDetailsSettingsInfoDetails from "@/components/module/administration/userManagement/userDetailsSettingsInfoDetails.vue";
import UserDetailsEducationalInfoDetails from "@/components/module/administration/userManagement/userDetailsEducationalInfoDetails.vue";
import UserDetailsAddressInfoDetails from "@/components/module/administration/userManagement/userDetailsAddressInfoDetails.vue";
import UserDetailsExperienceInfoDetails from "@/components/module/administration/userManagement/userDetailsExperienceInfoDetails.vue";
import UserDetailsOtherInfoDetails from "@/components/module/administration/userManagement/userDetailsOtherInfoDetails.vue";
import {fileServerUrl} from "@/store/api.js";
import ProfileUpdateDialog from "@/components/module/administration/userManagement/profileUpdateDialog.vue";

export default {

  components: {
    ProfileUpdateDialog,

    UserDetailsGeneralInfoDetails,
    UserDetailsPersonalInfoDetails,
    UserDetailsSettingsInfoDetails,
    UserDetailsEducationalInfoDetails,
    UserDetailsAddressInfoDetails,
    UserDetailsExperienceInfoDetails,
    UserDetailsOtherInfoDetails,
  },

  data: () => ({
    dialog: false,
    data:{},

    tab :('details'),
    mainId: null,
    userPersonalInfoData : null,
    userGeneralInfoData : null,
    userSettingsInfoData: null,
    userAddressInfoData: null,
    userOthersInfoData: null,
    userEducationInfoData : [],
    userExperienceInfoData: [],
    fileServerUrl,

    loading: false,
    profileLoading: false,

    assetRegistrationTabList: [
      { title: "Personal", icon: "mdi-shield-account", value: "personal" },
      { title: "Genaral", icon: "mdi-puzzle", value: "general" },
      { title: "Settings Info", icon: "mdi-cog", value: "settings-info" },
      { title: "Education", icon: "mdi-school", value: "educations" },
      { title: "Address", icon: "mdi-map-marker-outline", value: "address" },
      { title: "Experience", icon: "mdi-account-box", value: "experience" },
      { title: "Others", icon: "mdi-plus-box", value: "others" },
    ],
  }),

  watch: {
    tab(newVal, oldVal) {
      if(newVal === 'personal') {
        this.loading = true,
        this.$store.dispatch("getEmployeeDetails", this.mainId).then((response)=> {
          this.userPersonalInfoData = response.data?.data;
          this.profileLoading = false;
          this.loading = false;
        })
      }else if(newVal === 'general') {
        this.loading = true,
          this.$store.dispatch("getEmployeeGeneralInfo", this.mainId)
            .then((response) => {
              this.userGeneralInfoData = response?.data?.data;
              this.loading= false
            }).finally(() => {
            this.loading= false
          })
      } else if(newVal === 'address') {
        this.loading = true,
          this.$store.dispatch("addressInfo/fetchAddressInfoByEmployee", this.mainId)
            .then((response) => {
              this.userAddressInfoData = response?.data;
              this.loading= false
            }).finally(() => {
            this.loading= false
          })
      } else if(newVal === 'settings-info') {
        this.loading = true,
          this.$store.dispatch("settingsInfo/getSettingsInfoByEmployee", this.mainId)
            .then((response) => {
              this.userSettingsInfoData = response?.data?.data;
              this.loading= false
            }).finally(() => {
            this.loading= false
          })
      }else if(newVal === 'educations') {
        this.loading = true,
        this.$store.dispatch("educationalInfo/getEducationalInfoByEmployee", this.mainId)
          .then((response) => {
            this.userEducationInfoData = response?.data || [];
            this.loading= false
          }).finally(() => {
          this.loading= false
        })
      }else if(newVal === 'experience') {
        this.loading = true,
        this.$store.dispatch("previousEmploymentInfo/fetchPreviousEmploymentInfoByEmployee", this.mainId)
          .then((response) => {
            this.userExperienceInfoData = response?.data || [];
            this.loading= false
          }).finally(() => {
          this.loading= false
        })
      }else if(newVal === 'others') {
        this.loading = true,
        this.$store.dispatch("otherInfo/getOtherInfoByEmployee", this.mainId)
          .then((response) => {
            this.userOthersInfoData = response?.data?.data;
            this.loading= false
          }).finally(() => {
          this.loading= false
        })
      }
    },
  },

  created() {
    const id = this.$route.params.id;
    this.mainId = id;
    this.profileLoading = true;
    this.loading = true;
    this.$store.dispatch("getEmployeeDetails", id).then((response)=> {
      this.userPersonalInfoData = response.data?.data;
      this.profileLoading = false;
      this.loading = false;
    })
  },

  computed: { },
  methods: {
    editItem(id){
      this.data = id;
      this.dialog = true;
    },
  },
  setup() {},
  mounted() {},
  beforeUnmount() {}
}

</script>
